/* eslint-disable import/no-anonymous-default-export */
import {
  validateEmail,
  validateCRM,
  validateCpf,
  validateTypeUser,
  validatePhone,
  validateOccupation,
  validatePassword,
  // lookupCep,
} from '../utils';
import required from '../constants/required';
import { lowerTrimString } from '../normalize';

export default {

  validateCsvList: async (list, type) => {
    let valid = true;
    const errors = [];
    const pushObj = (index, key, value) => ({ line: index + 2, column: key, value });

    await Promise.all(list.map(async (row, index) => Promise.all(Object.keys(row).map(async (key) => {
      if (!row[key] && required[type].requiredColumns.includes(key)) {
        valid = false;
        errors.push(pushObj(index, key, row[key]));
      } else if (key === 'ar' && /[^\d]/g.test(row[key])) {
        valid = false;
        errors.push(pushObj(index, key, row[key]));
      } else if (key === 'tipo' && !validateTypeUser(row[key])) {
        valid = false;
        errors.push(pushObj(index, key, row[key]));
      } else if (key === 'email' && row[key] && !validateEmail(row[key])) {
        valid = false;
        errors.push(pushObj(index, key, row[key]));
      } else if (key === 'documento' && !validateCRM(row[key])) {
        valid = false;
        errors.push(pushObj(index, key, row[key]));
      } else if (key === 'cpf' && row[key] && !validateCpf(row[key], row.tipo)) {
        valid = false;
        errors.push(pushObj(index, key, row[key]));
      } else if (key === 'telefone' && row[key] && !validatePhone(row[key])) {
        valid = false;
        errors.push(pushObj(index, key, row[key]));
      } else if (key === 'funcao' && row[key] && !validateOccupation(row[key])) {
        valid = false;
        errors.push(pushObj(index, key, row[key]));
      } else if (key === 'senha' && row[key] && !validatePassword(row[key])) {
        valid = false;
        errors.push(pushObj(index, key, row[key]));
      } else if (key === 'representante' && row[key] && !validateEmail(row[key])) {
        valid = false;
        errors.push(pushObj(index, key, row[key]));
      } else if (key === 'tipo_usuario' && row[key] && !/^\d+$/.test(row[key])) {
        valid = false;
        errors.push(pushObj(index, key, row[key]));
      }
      // else if (key === 'cep' && row[key]) {
      //   const isValidCep = await lookupCep(row[key]);
      //   if (!isValidCep.success) {
      //     valid = false;
      //     errors.push(pushObj(index, key, row[key]));
      //   }
      // }
    }))));

    if (!valid) return { errors: [...new Set(errors)] };

    return valid;
  },

  validateCsvHeaders: (headers, type) => {
    let valid = true;
    const errors = [];
    const headersArray = headers.map(header => lowerTrimString(header)).slice();
    const requiredArray = required[type].requiredColumns.slice();
    const pushObj = key => ({ column: key });

    requiredArray.forEach((val) => {
      const normalizedVal = lowerTrimString(val);

      if (!headersArray.includes(normalizedVal)) {
        errors.push(pushObj(val));
        valid = false;
      }
    });

    if (!valid) return { errors: [...new Set(errors)] };

    return valid;
  },

};
